import React from 'react';
import styled from 'styled-components';
import { Space, TextBody, useMediaSize } from '@ally/metronome-ui';
import { formattedDate, getMarkerType, getStatus } from '../utils';
import TimelineTrackerMarker from './TimelineTrackerMarker';
import { trackerSteps } from '../../constants';
function getStatusContent({ activityName, statusHistory, step, }) {
    const useDelivered = (statusHistory === null || statusHistory === void 0 ? void 0 : statusHistory.status) === 'Completed' ||
        activityName === 'InternalTransfers';
    switch (step) {
        /* istanbul ignore next: `Confirmed` is likely unreachable code since it is not a timeline step, nervous to remove */
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            return activityName === 'ACHTransfer' ? 'Processing' : 'Ordered';
        case 'Completed':
        case 'Posted':
            return useDelivered ? 'Delivered' : 'Deliver On';
        default:
            return step;
    }
}
const TrackerStep = styled.li `
  ${({ hasProgress, markerType, status, theme: { colors, media } }) => `
      flex: 1 1 0%;
      margin: 0;
      padding: 0;
      counter-increment: counter;
      min-width: 22px;

      &:last-child {
        > div::after {
          display: none;
        }
      }

      ${media.down('md')} {
        min-height: 50px;
        display: flex;
        align-items: center;
        position: relative;

        &:before {
          content: '';
          display: block;
          position: absolute;
          background-color: ${status === 'Success' ? colors.plum : colors['slate-2']};
          ${(markerType === 'start' && hasProgress) ||
    (markerType === 'default' && status === 'Success')
    ? `background-color: ${colors.plum};`
    : `background-color: ${colors['slate-2']};`}
          top: 11px;
          left: 11px;
          width: 1px;
          height: 100%;
        }

        &:last-child {
          :before {
            display: none;
          }
        }
      }
  `}
`;
const StyledTextBody = styled(TextBody) `
  ${({ status, theme: { colors } }) => `
      ${status === 'Current' || status === 'Warning' || !status
    ? `font-weight: bold;`
    : ``}
      ${!status ? `color: ${colors['slate-400']};` : ``}
  `}
`;
const TimelineTrackerStep = ({ event, stepStatus, statusHistory, step, }) => {
    const { deliverOnDate } = event.eventModelData;
    const isMdUp = useMediaSize('MdUp');
    const showDeliverOnDate = event.activityName === 'ACHTransfer' && step === 'Completed';
    const markerType = getMarkerType({ event, step });
    const firstStepStatus = trackerSteps[event.activityName][0];
    const isFirstStep = step === firstStepStatus;
    const hasProgress = getStatus({
        activityName: event.activityName,
        currentStatus: event.statuses[0].status,
    }) !== firstStepStatus;
    return (React.createElement(TrackerStep, { hasProgress: hasProgress, markerType: markerType, status: stepStatus },
        React.createElement(TimelineTrackerMarker, { isFirstStep: isFirstStep, hasProgress: hasProgress, markerType: markerType, status: stepStatus }),
        React.createElement(TextBody, { tag: "div", size: "sm" },
            React.createElement(Space, { pt: isMdUp ? 'xxs' : 'none' },
                React.createElement(StyledTextBody, { tag: "p", size: "xs", status: stepStatus }, getStatusContent({
                    activityName: event.activityName,
                    statusHistory,
                    step,
                }))),
            statusHistory && !showDeliverOnDate && (React.createElement(StyledTextBody, { tag: "p", size: "xs", status: stepStatus }, formattedDate(statusHistory.eventDateTime, 'MMM D'))),
            showDeliverOnDate && (React.createElement(StyledTextBody, { tag: "p", size: "xs", status: stepStatus }, formattedDate(deliverOnDate, 'MMM D'))))));
};
export default TimelineTrackerStep;
//# sourceMappingURL=TimelineTrackerStep.js.map